import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import GenericForm from '../../GenericForm';
import { RENTAL_TEXTILE_LAUNDRY } from '../../../constants';
import CustomAccordion from '../../CustomAccordion';
import OutputTable from '../../OutputTable';
import ApiClient from '../../../apisClient';
import CustomAlert from '../../Alert';

const api = new ApiClient();
const AmountOfChemAccordian = () => {
  const [frequency, setFrequency] = React.useState('');
  const [liter_per_year, setLiters_per_year] = React.useState('');
  const [over100CleaningCycles, setOver100CleaningCycles] = React.useState('');
  const [submittedData, setSubmittedData] = React.useState(null);
  const [totalCost, setTotalCost] = React.useState(null);
  const [alertMessage, setAlertMessage] = React.useState('');

  const frequencyMapping = {
    'per week': 2,
    'bi week': 4,
    'per month': 8.5,
    'per 2 months': 17,
  };

  const handleFrequencyChange = (event) => {
    const selectedFrequency = event.target.value;
    setFrequency(selectedFrequency);
    setOver100CleaningCycles(frequencyMapping[selectedFrequency]);
  };

  const handleLitersPerYearChange = (event) => {
    setLiters_per_year(event.target.value);
  };

  const isFormValid = () => {
    if (liter_per_year === '' || frequency === '') {
      setAlertMessage('Please fill in all fields.');
      return false;
    }else if (isNaN(liter_per_year)) {
      setAlertMessage('Liters of re-impregnation chemicals used per year must be a number.');
      return false; 
    }
    else if (liter_per_year < 0) {
      setAlertMessage('Liters of re-impregnation chemicals used per year must be greater than zero.');
      return false;
    }else{
      setAlertMessage('');
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!isFormValid()) {
      return;
    }
    const payload = {
      amount_of_L_per_year: liter_per_year,
      no_of_years: frequencyMapping[frequency],
    };
    const response = await api.post('/api/v1/amount-of-chemicals', payload);
    const responseData =  response;
    setTotalCost(responseData["amount of L of chemicals used"]);
   setSubmittedData({
      amount_of_L_per_year: liter_per_year,
      frequency,
      no_of_years: frequencyMapping[frequency],
      totalCost: responseData["amount of L of chemicals used"],
    });
  };

  //handle reset

  const handleReset = () => {
    setLiters_per_year('');
    setFrequency('');
    setOver100CleaningCycles('');
    setSubmittedData(null);
  };

  const formTableRows = [
    {
      title: RENTAL_TEXTILE_LAUNDRY.ENVIRONMENTAL_IMPACT_ACCORDIAN_TEXT,
      description: '',
      fields: [
        {
          label: 'Liters of re-impregnation chemicals used per year:',
          width: '370px',
          component: [
            <TextField size="small" type='number' className="textFieldCustom" value={liter_per_year} onChange={handleLitersPerYearChange} placeholder='Enter value'/>,
          ],
        },
        {
          label: 'Selected frequency of cycle:',
          width: '370px',
          component: [
            <TextField select size="small" label="Select frequency" className="textFieldCustom" value={frequency} onChange={handleFrequencyChange} sx={{textAlign:'left' }}>
            <MenuItem value="per week">Per week</MenuItem>
            <MenuItem value="bi week">Bi Week</MenuItem>
            <MenuItem value="per month">Per month</MenuItem>
            <MenuItem value="per 2 months">Per 2 months</MenuItem>
          </TextField>,
          ],
        },
        {
          label: 'Over 100 cleaning cycles (years):',
          width: '370px',
          component: [
            <TextField size="small" disabled className="textFieldCustom" value={over100CleaningCycles} placeholder='X'/>,
          ],
        },
      ],
      onSubmit: handleSubmit,
    },
  ];

  const section_3 = [
    {
      title: 'Amount of chemicals used for repellency re-impregnation over 100 cleaning cycles',
      content: (
        <>
          <GenericForm
            title={formTableRows[0].title}
            description={formTableRows[0].description}
            fields={formTableRows[0].fields}
            onSubmit={formTableRows[0].onSubmit}
            onReset={handleReset}
          />
          {alertMessage && <CustomAlert text={alertMessage} />}
          {submittedData && !alertMessage && (
            <OutputTable
              title="Amount of chemicals"
              data={[
                {
                  label: formTableRows[0].fields[0].label,
                  value: submittedData.amount_of_L_per_year,
                },
                {
                  label: formTableRows[0].fields[1].label,
                  value:  submittedData.frequency,
                },
                {
                  label: formTableRows[0].fields[2].label,
                  value: submittedData.no_of_years,
                },
                {
                  label: 'Amount of chemicals used in liters',
                  value: submittedData.totalCost,
                },
              ]}
            />
          )}
        </>
      ),
    },
  ];

  return <CustomAccordion sections={section_3} isExpanded={true} />;
};

export default AmountOfChemAccordian;